export default () => ({
    pt: {
        _date: { ddOfMmmm: 'DD [de] MMMM' },
    },
    en: {
        _date: { ddOfMmmm: 'MMMM DD' },
    },
});
